import React from 'react'
import Tag from './../../components/Tag/Tag'
import { Grid } from '@mui/material'
import BasicCard from './../../components/BasicCard/BasicCard'
import RatingComponent from './../../components/RatingComponent/RatingComponent'
import { Stack } from './../../utils/Stack'
import './About.css'

export const CompRating = React.createContext()
const About = () => {
  return (
    <div>
      <div>
        <Tag tagName='About me' />
        <div className='about-margin about-me'>
          <p>
            Thanks for stopping by, I am Anthony Michael. I am a Frontend
            Developer with experience in HTML, CSS, Material UI, TailwindSass,
            Javascript, React, Redux and also have three years of professional
            experience in the field. My goal is to fulfill the growing need for
            fast and efficient web apps and websites. I can also build websites
            that are responsive on all devices, which can be great for SEO, and
            use my skills with pure dedication to deliver work on time. Let me
            take a step back. Contact me if you have any questions.
          </p>
          <p>
            Front-end development satisfies my need for creativity, which is the
            primary reason for my interest. I was able to put my ideas into
            digital form and get a fast result. I still smile whenever I think
            about creating my first HTML page and opening it in the browser.
            Suddenly, a lifetime of possibilities was revealed to me. It is an
            amazing experience to be able to bring my imagination to
            life. Second of all, frontend skills are in demand across many
            industries, so finding something I'm interested in is not a needle
            in a haystack. I've also grown very passionate about building
            effective user interfaces (UIs), and I'm fortunate to earn a very
            comfortable living from it. Although it is certainly not without its
            challenges, if you enjoy your work and are able to serve others, the
            results will be far more rewarding. My career as a web developer
            enables me to bring my ideas to life and show others what I see as
            an ideal world.
          </p>
        </div>
      </div>
      <div className='stack'>
        <Tag tagName='my stack' />
        <div className='stack-margin'>
          <Grid container spacing={2}>
            {Stack.map((card, id = 1) => {
              const { icon, language, ratingValue } = card
              return (
                <Grid key={id++} item xs={12} sm={6} md={3} lg={3}>
                  <CompRating.Provider value={[icon, language, ratingValue]}>
                    <BasicCard>
                      <RatingComponent />
                    </BasicCard>
                  </CompRating.Provider>
                </Grid>
              )
            })}
          </Grid>
        </div>
      </div>
    </div>
  )
}

export default About
